/* =========================================================
   LOOK TWICE — interactions
   ========================================================= */
(() => {
  'use strict';

  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const lerp  = (a, b, t) => a + (b - a) * t;
  const clamp = (v, min, max) => Math.min(Math.max(v, min), max);

  const reduced   = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------------------------------------------------
     1. Découpe du titre en caractères
  --------------------------------------------------- */
  const splitTitle = () => {
    $$('#heroTitle .line').forEach((line, li) => {
      const text = line.dataset.text || '';
      line.innerHTML = '';
      [...text].forEach((ch, i) => {
        const s = document.createElement('span');
        s.className = 'char';
        s.textContent = ch === ' ' ? ' ' : ch;
        s.style.transitionDelay = `${0.62 + li * 0.12 + i * 0.045}s`;
        line.appendChild(s);
      });
    });
  };
  splitTitle();

  /* ---------------------------------------------------
     2. Préchargement
  --------------------------------------------------- */
  const loader    = $('#loader');
  const loaderBar = $('#loaderBar');
  const loaderNum = $('#loaderNum');

  let loaderStarted = false;
  const runLoader = () => {
    if (loaderStarted) return;
    loaderStarted = true;
    let pct = 0;
    const step = () => {
      pct += (100 - pct) * 0.14 + Math.random() * 2.4;
      if (pct > 99.4) pct = 100;
      loaderNum.textContent = Math.floor(pct);
      loaderBar.style.transform = `scaleX(${pct / 100})`;
      if (pct < 100) return requestAnimationFrame(step);
      setTimeout(() => {
        loader.classList.add('is-done');
        document.body.classList.add('is-loaded');
      }, 340);
    };
    requestAnimationFrame(step);
  };

  if (reduced) {
    loaderNum.textContent = '100';
    loader.classList.add('is-done');
    document.body.classList.add('is-loaded');
  } else {
    // On n'attend plus le chargement des 51 visuels : dès que le document
    // est lisible, le préchargement s'achève. Attendre `load` faisait
    // patienter plusieurs secondes devant un écran noir avant la boutique.
    if (document.readyState !== 'loading') runLoader();
    else document.addEventListener('DOMContentLoaded', runLoader);
    setTimeout(runLoader, 1100);
  }

  /* ---------------------------------------------------
     3. Curseur personnalisé
  --------------------------------------------------- */
  const cursor    = $('#cursor');
  const cursorDot = $('#cursorDot');
  const cursorLbl = $('#cursorLabel');
  const pointer   = { x: innerWidth / 2, y: innerHeight / 2 };
  const ring      = { x: pointer.x, y: pointer.y };
  const dot       = { x: pointer.x, y: pointer.y };

  if (!finePointer) document.body.classList.add('no-cursor');

  addEventListener('pointermove', e => {
    pointer.x = e.clientX;
    pointer.y = e.clientY;
  }, { passive: true });

  /* Cibles qui modifient le curseur */
  const hoverables = 'a, button, .fem__media, .service';
  document.addEventListener('pointerover', e => {
    const t = e.target.closest(hoverables);
    if (!t) return;
    const label = t.dataset.cursor || t.closest('[data-cursor]')?.dataset.cursor;
    if (label) {
      cursorLbl.textContent = label;
      cursor.classList.add('is-hover');
    } else {
      cursor.classList.add('is-small');
    }
  });
  document.addEventListener('pointerout', e => {
    if (!e.target.closest(hoverables)) return;
    cursor.classList.remove('is-hover', 'is-small');
  });

  /* ---------------------------------------------------
     4. Menu mobile
  --------------------------------------------------- */
  const burger = $('#burger');
  const menu   = $('#menu');
  const toggleMenu = force => {
    const open = force ?? !menu.classList.contains('is-open');
    menu.classList.toggle('is-open', open);
    burger.classList.toggle('is-open', open);
    document.documentElement.classList.toggle('is-locked', open);
    burger.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
  };
  burger.addEventListener('click', () => toggleMenu());
  $$('#menu a').forEach(a => a.addEventListener('click', () => toggleMenu(false)));
  addEventListener('keydown', e => { if (e.key === 'Escape') toggleMenu(false); });

  /* ---------------------------------------------------
     5. Barre de navigation + progression
  --------------------------------------------------- */
  const nav      = $('#nav');
  const progress = $('#progress');
  let lastY = 0;

  const onScrollNav = () => {
    const y = scrollY;
    nav.classList.toggle('is-stuck', y > 40);
    nav.classList.toggle('is-hidden', y > 420 && y > lastY && !menu.classList.contains('is-open'));
    const max = document.documentElement.scrollHeight - innerHeight;
    progress.style.transform = `scaleX(${max > 0 ? clamp(y / max, 0, 1) : 0})`;
    lastY = y;
  };

  /* ---------------------------------------------------
     6. Révélations au défilement
  --------------------------------------------------- */
  const io = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const siblings = [...(el.parentElement?.children || [])].filter(n => n.classList.contains('reveal'));
      el.style.transitionDelay = `${clamp(siblings.indexOf(el), 0, 8) * 0.08}s`;
      el.classList.add('is-in');
      obs.unobserve(el);
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
  $$('.reveal').forEach(el => io.observe(el));

  /* ---------------------------------------------------
     7. Manifeste — révélation mot à mot
  --------------------------------------------------- */
  const mText = $('#manifesteText');
  const mWords = (() => {
    const words = mText.textContent.trim().split(/\s+/);
    mText.innerHTML = words
      .map(w => `<span class="w">${w}</span>`)
      .join(' ');
    return $$('.w', mText);
  })();

  const updateManifeste = () => {
    const r = mText.getBoundingClientRect();
    const start = innerHeight * 0.86;
    const end   = innerHeight * 0.22;
    const p = clamp((start - r.top) / (start - end + r.height * 0.55), 0, 1);
    const active = Math.round(p * mWords.length);
    mWords.forEach((w, i) => w.classList.toggle('on', i < active));
  };

  /* ---------------------------------------------------
     8. Bandeau défilant
  --------------------------------------------------- */
  // Le bandeau a été retiré de l'accueil ; il peut revenir sur une autre
  // page. Sans ces gardes, son absence lèverait une erreur qui
  // interromprait tout le script — panier et tailles compris.
  const track = $('#marqueeTrack');
  const baseSet = track && track.firstElementChild;
  const buildMarquee = () => {
    if (!track || !baseSet) return;
    $$('.marquee__set', track).slice(1).forEach(n => n.remove());
    const need = Math.ceil((innerWidth * 2) / Math.max(baseSet.offsetWidth, 1)) + 1;
    for (let i = 0; i < need; i++) track.appendChild(baseSet.cloneNode(true));
  };
  buildMarquee();

  let mX = 0, mVel = 0.7;
  const runMarquee = () => {
    if (!track || !baseSet) return;
    const w = baseSet.offsetWidth;
    mX -= mVel;
    if (w && mX <= -w) mX += w;
    track.style.transform = `translate3d(${mX}px,0,0)`;
    mVel = lerp(mVel, 0.7, 0.04);
  };

  /* ---------------------------------------------------
     9. Aperçu au survol des expertises
  --------------------------------------------------- */
  const preview = $('#servicePreview');
  const meshes = {
    1: 'radial-gradient(60% 60% at 25% 20%, #7A7A88, transparent 60%), linear-gradient(150deg,#3A3A44,#0B0B0E)',
    2: 'radial-gradient(55% 55% at 70% 25%, #93939F, transparent 58%), linear-gradient(30deg,#101014,#4A4A55)',
    3: 'radial-gradient(50% 50% at 35% 70%, #85858F, transparent 56%), linear-gradient(210deg,#0B0B0E,#43434D)',
    4: 'radial-gradient(65% 55% at 50% 15%, #A6A6B2, transparent 62%), linear-gradient(140deg,#2B2B33,#0A0A0D)'
  };
  const prev = { x: innerWidth / 2, y: innerHeight / 2 };

  if (finePointer) {
    $$('.service').forEach(li => {
      li.addEventListener('pointerenter', () => {
        preview.style.setProperty('--mesh', meshes[li.dataset.mesh]);
        preview.classList.add('is-on');
      });
      li.addEventListener('pointerleave', () => preview.classList.remove('is-on'));
    });
  }

  /* ---------------------------------------------------
     10. Parallaxe des visuels
  --------------------------------------------------- */
  const parallaxItems = $$('[data-parallax]').map(el => ({
    el,
    inner: $('.mesh', el),
    amt: parseFloat(el.dataset.parallax) || 0.05
  })).filter(i => i.inner);

  const updateParallax = () => {
    const vh = innerHeight;
    parallaxItems.forEach(({ el, inner, amt }) => {
      const r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      const centered = (r.top + r.height / 2 - vh / 2) / vh;
      inner.style.setProperty('--py', `${(-centered * amt * 100).toFixed(2)}px`);
    });
  };

  /* ---------------------------------------------------
     11. Compteurs
  --------------------------------------------------- */
  const countIO = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      const target = parseInt(el.dataset.count, 10);
      const suffix = el.dataset.suffix || '';
      const dur = 1700;
      const t0 = performance.now();
      const tick = now => {
        const p = clamp((now - t0) / dur, 0, 1);
        const eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
      obs.unobserve(el);
    });
  }, { threshold: 0.6 });
  $$('.stat__num').forEach(el => countIO.observe(el));

  /* ---------------------------------------------------
     12. Boutons magnétiques
  --------------------------------------------------- */
  if (finePointer && !reduced) {
    $$('.magnetic').forEach(el => {
      el.addEventListener('pointermove', e => {
        const r = el.getBoundingClientRect();
        const x = (e.clientX - r.left - r.width / 2) * 0.28;
        const y = (e.clientY - r.top - r.height / 2) * 0.42;
        el.style.transform = `translate(${x}px, ${y}px)`;
        el.style.transition = 'transform .18s ease-out';
      });
      el.addEventListener('pointerleave', () => {
        el.style.transition = 'transform .7s cubic-bezier(.22,1,.36,1)';
        el.style.transform = '';
      });
    });
  }

  /* ---------------------------------------------------
     13. Lueur du hero suivant la souris
  --------------------------------------------------- */
  const heroGlow = $('#heroGlow');
  const hero = $('#hero');
  if (finePointer && !reduced) {
    hero.addEventListener('pointermove', e => {
      const r = hero.getBoundingClientRect();
      const x = (e.clientX - r.width / 2) * 0.09;
      const y = (e.clientY - r.height / 2) * 0.09;
      heroGlow.style.transform = `translate(calc(-50% + ${x}px), calc(-50% + ${y}px))`;
    });
  }

  /* ---------------------------------------------------
     14. Copie de l'adresse e-mail
  --------------------------------------------------- */
  const toast = $('#toast');
  const showToast = msg => {
    toast.textContent = msg;
    toast.classList.add('is-on');
    clearTimeout(showToast._t);
    showToast._t = setTimeout(() => toast.classList.remove('is-on'), 2200);
  };
  const mail = $('.contact__mail');
  mail.addEventListener('click', async e => {
    if (!navigator.clipboard) return;            // laisse le mailto: prendre le relais
    e.preventDefault();
    try {
      await navigator.clipboard.writeText('looktwice.fr@gmail.com');
      showToast('Adresse copiée dans le presse-papiers');
    } catch {
      location.href = mail.getAttribute('href');
    }
  });

  /* ---------------------------------------------------
     15. Collection — tailles et panier Shopify

     Différence majeure avec le site statique : le panier n'est plus
     dans localStorage, il vit chez Shopify. Toutes les opérations
     passent par son API AJAX, et le paiement est pris en charge par
     le tunnel Shopify — on ne collecte donc plus l'adresse ici.
  --------------------------------------------------- */
  const cartBtn   = $('#cart');
  const cartCount = $('#cartCount');

  const MAX_QTE_LIGNE = 10;
  const euros = c => (c / 100).toFixed(2).replace('.', ',').replace(',00', '') + ' €';

  let panier = { items: [], item_count: 0, total_price: 0 };

  const bumpCart = () => {
    const n = panier.item_count || 0;
    cartCount.textContent = n;
    cartBtn.classList.toggle('has-items', n > 0);
    cartBtn.classList.remove('is-bump');
    void cartBtn.offsetWidth;
    if (n > 0) cartBtn.classList.add('is-bump');
    cartBtn.setAttribute('aria-label', `Panier, ${n} article${n > 1 ? 's' : ''}`);
  };

  async function lirePanier() {
    const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    panier = await r.json();
    bumpCart();
    rendrePanier();
  }

  /* Les cartes de la grille : choix de la taille puis ajout. */
  $$('.tee, .fem').forEach(card => {
    const stage   = $('.tee__stage', card);
    const sizes   = $$('.size', card);
    const sizeRow = $('.sizes', card);
    const add     = $('.tee__add', card);
    if (!add || !sizeRow) return;

    sizes.forEach(sz => sz.addEventListener('click', () => {
      if (sz.classList.contains('is-out')) {
        showToast(`Taille ${sz.textContent.trim()} épuisée`);
        return;
      }
      sizes.forEach(s => s.classList.remove('is-on'));
      sz.classList.add('is-on');
    }));

    add.addEventListener('click', async () => {
      const chosen = $('.size.is-on', card);
      if (!chosen) {
        sizeRow.classList.remove('is-shake');
        void sizeRow.offsetWidth;
        sizeRow.classList.add('is-shake');
        showToast('Choisis d’abord une taille');
        return;
      }

      const variante = chosen.dataset.variante;
      add.disabled = true;
      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variante), quantity: 1 }] }),
        });
        if (!r.ok) {
          const err = await r.json().catch(() => ({}));
          showToast(err.description || 'Cet article n’a pas pu être ajouté');
          return;
        }
        await lirePanier();
        showToast(`${add.dataset.name} — taille ${chosen.textContent.trim()} ajoutée au panier`);
      } catch {
        showToast('Connexion impossible');
      } finally {
        add.disabled = false;
      }
    });

    if (stage && finePointer && !reduced) {
      stage.addEventListener('pointermove', e => {
        const r = stage.getBoundingClientRect();
        const px = (e.clientX - r.left) / r.width  - 0.5;
        const py = (e.clientY - r.top)  / r.height - 0.5;
        stage.style.setProperty('--ry', `${(px * 17).toFixed(2)}deg`);
        stage.style.setProperty('--rx', `${(-py * 14).toFixed(2)}deg`);
      });
      stage.addEventListener('pointerleave', () => {
        stage.style.setProperty('--ry', '0deg');
        stage.style.setProperty('--rx', '0deg');
      });
    }
  });

  /* ---------------------------------------------------
     15b. Tiroir du panier
  --------------------------------------------------- */
  const drawer     = $('#drawer');
  const drawerVeil = $('#drawerVeil');
  const lignesEl   = $('#drawerLines');
  const videEl     = $('#drawerEmpty');
  const sumItems   = $('#sumItems');
  const noteEl     = $('#drawerNote');
  const payBtn     = $('#payBtn');
  const cgvBox     = $('#cgvOk');
  const errEl      = $('#formErr');
  const videBtn    = $('#viderPanier');

  videBtn?.addEventListener('click', async () => {
    try {
      await fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } });
      await lirePanier();
      showToast('Panier vidé');
    } catch { showToast('Connexion impossible'); }
  });

  function ligneDOM(ligne) {
    const li = document.createElement('li');
    li.className = 'dline';

    if (ligne.image) {
      const img = document.createElement('img');
      img.className = 'dline__img';
      img.src = ligne.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2');
      img.alt = ''; img.width = 80; img.height = 80; img.loading = 'lazy';
      li.append(img);
    }

    const info = document.createElement('div');
    info.className = 'dline__info';

    const nom = document.createElement('p');
    nom.className = 'dline__nom';
    nom.textContent = ligne.product_title;
    info.append(nom);

    const meta = document.createElement('p');
    meta.className = 'dline__meta';
    meta.textContent = `Taille ${ligne.variant_title} — ${euros(ligne.price)}`;
    info.append(meta);

    const qte = document.createElement('div');
    qte.className = 'dqte';

    const moins = document.createElement('button');
    moins.type = 'button'; moins.className = 'dqte__b'; moins.textContent = '−';
    moins.setAttribute('aria-label', `Retirer un ${ligne.product_title}`);
    moins.addEventListener('click', () => changerQte(ligne.key, ligne.quantity - 1));

    const val = document.createElement('span');
    val.className = 'dqte__n';
    val.textContent = ligne.quantity;

    const plus = document.createElement('button');
    plus.type = 'button'; plus.className = 'dqte__b'; plus.textContent = '+';
    plus.setAttribute('aria-label', `Ajouter un ${ligne.product_title}`);
    plus.addEventListener('click', () => {
      if (ligne.quantity >= MAX_QTE_LIGNE) {
        showToast(`Maximum ${MAX_QTE_LIGNE} exemplaires par taille`);
        return;
      }
      changerQte(ligne.key, ligne.quantity + 1);
    });

    qte.append(moins, val, plus);
    info.append(qte);
    li.append(info);

    const sup = document.createElement('button');
    sup.type = 'button'; sup.className = 'dline__x'; sup.innerHTML = '&times;';
    sup.setAttribute('aria-label', `Supprimer ${ligne.product_title}`);
    sup.addEventListener('click', () => changerQte(ligne.key, 0));
    li.append(sup);

    return li;
  }

  async function changerQte(key, quantite) {
    try {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantite }),
      });
      panier = await r.json();
      bumpCart();
      rendrePanier();
    } catch {
      showToast('Connexion impossible');
    }
  }

  function rendrePanier() {
    if (!drawer) return;

    /* Shopify range les nouveaux ajouts en fin de liste. On inverse :
       le dernier article ajouté apparaît en premier, sous les yeux.
       Sans ça, on croit avoir ajouté le mauvais t-shirt alors qu'on
       regarde simplement une ligne plus ancienne. */
    const lignes = (panier.items || []).slice().reverse();
    lignesEl.replaceChildren(...lignes.map(ligneDOM));
    if (videBtn) videBtn.hidden = lignes.length === 0;

    const vide = lignes.length === 0;
    videEl.hidden   = !vide;
    lignesEl.hidden = vide;

    sumItems.textContent = euros(panier.total_price || 0);

    /* Shopify ne connaît les frais de port qu'au tunnel de paiement :
       on annonce le seuil au lieu d'inventer un montant. */
    const reste = 11000 - (panier.total_price || 0);
    noteEl.textContent = vide ? ''
      : (reste > 0 ? `Encore ${euros(reste)} et la livraison passe offerte.`
                   : 'Livraison offerte.');

    payBtn.disabled = vide;
  }

  function ouvrirPanier() {
    if (!drawer) return;
    rendrePanier();
    drawer.hidden = false;
    void drawer.offsetWidth;
    drawer.classList.add('is-on');
    document.documentElement.classList.add('is-locked');
    $('#drawerClose')?.focus();
  }

  function fermerPanier() {
    if (!drawer) return;
    drawer.classList.remove('is-on');
    document.documentElement.classList.remove('is-locked');
    setTimeout(() => { drawer.hidden = true; }, 400);
  }

  payBtn?.addEventListener('click', () => {
    if (cgvBox && !cgvBox.checked) {
      errEl.textContent = 'Merci d’accepter les conditions générales de vente.';
      cgvBox.focus();
      return;
    }
    payBtn.disabled = true;
    payBtn.textContent = 'Redirection…';
    location.href = '/checkout';
  });

  cartBtn.addEventListener('click', ouvrirPanier);
  $('#drawerClose')?.addEventListener('click', fermerPanier);
  drawerVeil?.addEventListener('click', fermerPanier);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && drawer && !drawer.hidden) fermerPanier();
  });

  lirePanier();


  /* ---------------------------------------------------
     16. Visionneuse
  --------------------------------------------------- */
  const lb      = $('#lightbox');
  const lbImg   = $('#lbImg');
  const lbCap   = $('#lbCap');
  let lbList = [], lbIndex = 0;

  const lbShow = i => {
    const total = lbList.length;
    lbIndex = (i + total) % total;
    const card = lbList[lbIndex];
    const img  = $('img', card);
    lbImg.src = img.getAttribute('src');
    lbImg.alt = img.getAttribute('alt') || '';
    const nom  = $('.fem__top h3', card)?.textContent ?? '';
    const prix = $('.fem__price', card)?.textContent ?? '';
    const desc = $('.fem__desc', card)?.textContent ?? '';
    lbCap.innerHTML = `<b>${nom}</b> — ${prix}<br><span>${desc}</span>`;
  };

  const lbOpen = card => {
    /* Une seule fiche à la fois, délibérément. La visionneuse permettait
       autrefois de passer au modèle suivant — mais le bouton « Ajouter »
       restait celui de la fiche ouverte au départ. On pouvait donc
       regarder un t-shirt et en acheter un autre. Sur une boutique, ce
       risque ne vaut aucun confort de navigation. */
    lbList = [card];
    lbShow(0);
    lb.hidden = false;
    requestAnimationFrame(() => lb.classList.add('is-on'));
    document.documentElement.classList.add('is-locked');
  };

  const lbClose = () => {
    lb.classList.remove('is-on');
    document.documentElement.classList.remove('is-locked');
    setTimeout(() => { lb.hidden = true; lbImg.src = ''; }, 400);
  };

  document.addEventListener('click', e => {
    const media = e.target.closest('.fem__media');
    if (media) { lbOpen(media.closest('.fem')); return; }
    if (e.target.closest('#lbClose') || e.target === lb) { lbClose(); }
  });

  addEventListener('keydown', e => {
    if (lb.hidden) return;
    if (e.key === 'Escape') lbClose();
  });

  /* ---------------------------------------------------
     17. Horloge de Paris
  --------------------------------------------------- */
  const clock = $('#clock');
  const tickClock = () => {
    clock.textContent = new Intl.DateTimeFormat('fr-FR', {
      timeZone: 'Europe/Paris', hour: '2-digit', minute: '2-digit', second: '2-digit'
    }).format(new Date());
  };
  tickClock();
  setInterval(tickClock, 1000);

  /* ---------------------------------------------------
     18. Boucle d'animation unique
  --------------------------------------------------- */
  let scrollDirty = true;
  addEventListener('scroll', () => {
    scrollDirty = true;
    mVel = clamp(mVel + Math.abs(scrollY - lastY) * 0.04, 0.7, 8);
  }, { passive: true });
  addEventListener('resize', () => { scrollDirty = true; buildMarquee(); });

  const frame = () => {
    if (finePointer) {
      ring.x = lerp(ring.x, pointer.x, 0.16);
      ring.y = lerp(ring.y, pointer.y, 0.16);
      dot.x  = lerp(dot.x, pointer.x, 0.45);
      dot.y  = lerp(dot.y, pointer.y, 0.45);
      cursor.style.transform    = `translate3d(${ring.x}px, ${ring.y}px, 0)`;
      cursorDot.style.transform = `translate3d(${dot.x}px, ${dot.y}px, 0)`;

      prev.x = lerp(prev.x, pointer.x, 0.11);
      prev.y = lerp(prev.y, pointer.y, 0.11);
      preview.style.left = `${prev.x}px`;
      preview.style.top  = `${prev.y}px`;
    }

    if (!reduced) runMarquee();

    if (scrollDirty) {
      onScrollNav();
      updateManifeste();
      updateParallax();
      scrollDirty = false;
    }

    requestAnimationFrame(frame);
  };
  requestAnimationFrame(frame);

  /* Premier calcul */
  onScrollNav();
  updateManifeste();
  updateParallax();
})();
